import { Attach, Spin } from 'lego-on-react';
import React from 'react';

import i18n from '@yandex-int/i18n';
import * as keyset from 'i18n/Settings';
import block from 'propmods';

import { uploadImage } from '../../api';
import { ApiError } from '../../api/error';

import './Uploader.scss';

const t = i18n(keyset);

interface UploaderProps {
    skillId: string;
    disabled: boolean;
    onChange: (value: string | null, error?: string) => void;
    url: string;
    imageId: string | null;
    imageColor: string;
}

interface UploaderState {
    progress: boolean;
    url: string;
}

const b = block('Uploader');

export default class Uploader extends React.Component<UploaderProps, UploaderState> {
    constructor(props: UploaderProps) {
        super(props);
        this.state = {
            progress: false,
            url: props.url,
        };
    }

    public componentDidUpdate(prevProps: UploaderProps) {
        if (prevProps.url !== this.props.url) {
            this.setState({ url: this.props.url });
        }
    }

    public render() {
        const { props, state } = this;

        return (
            <div {...b()}>
                {state.url && <img src={state.url} style={{ backgroundColor: props.imageColor }} />}
                <Attach
                    onChange={(event) => {
                        const target = event.target as HTMLInputElement;
                        const file = (target.files || [])[0];

                        if (file) {
                            this.setState({ progress: true });

                            uploadImage(props.skillId, file)
                                .then((image) => {
                                    props.onChange(image.id, '');

                                    this.setState({ progress: false, url: image.url });
                                })
                                .catch((err) => {
                                    let { message } = err;

                                    if (err instanceof ApiError) {
                                        if (err.code === 413) {
                                            message = t('upload-error-max-size');
                                        } else if (err.code === 400 || err.code === 415) {
                                            message = t('upload-error-format');
                                        }
                                    }

                                    props.onChange(this.props.imageId, message);
                                    this.setState({ progress: false });
                                });
                        }
                    }}
                    size="s"
                    theme="normal"
                    disabled={props.disabled || state.progress}
                >
                    {this.state.url ? t('upload-choose-other') : t('upload-choose-file')}
                </Attach>

                {state.progress && <Spin size="xxs" progress />}
            </div>
        );
    }
}
